export default {
  namespaced  : true,

  state       : {
    parkNoteId        : null,
    
    parkNoteComments  : [],

    metaKeys          : ['behaviour', 'loaded', 'page', 'lastPage', 'total', 'currentPage'],
  },

  mutations   : {
    setParkNoteId(state, payload){
      state.parkNoteId = payload.parkNoteId;
    },

    changeParkNoteCommentMetaData(state, payload){
      if(typeof state.parkNoteComments[payload.parkNoteCommentIndex] === 'undefined') return;

      // List以外のMetaKeyを処理します。
      for(let key of state.metaKeys){
        if(typeof payload[key] !== 'undefined'){
          state.parkNoteComments[payload.parkNoteCommentIndex][key] = payload[key];
        }
      }
    },

    changeParkNoteCommentListData(state, payload){
      if(typeof payload.list === 'undefined') return;
      if(payload.list.length === 0) return;
      
      for(let i = 0; i < state.parkNoteComments.length; i++){
        if(payload.parkNoteId === state.parkNoteComments[i].parkNoteId){
          switch(state.parkNoteComments[i].behaviour){
            case 'refresh':
              payload.list = payload.list.reverse();

              state.parkNoteComments[i].list = payload.list;
            break;
  
            case 'prev':
              for(let parkNoteComment of payload.list){
                let couldRegist = true;
  
                for(let registerdParkNoteComment of state.parkNoteComments[i].list){
                  if(registerdParkNoteComment.id === parkNoteComment.id){
                    couldRegist = false;
                  }
                }
  
                if(couldRegist){
                  state.parkNoteComments[i].list.unshift(parkNoteComment);
                }
              }
            break;
  
            case 'fetch':
              for(let parkNoteComment of payload.list){
                let couldRegist = true;
  
                for(let registerdParkNoteComment of state.parkNoteComments[i].list){
                  if(registerdParkNoteComment.id === parkNoteComment.id){
                    couldRegist = false;
                  }
                }
  
                if(couldRegist){
                  state.parkNoteComments[i].list.push(parkNoteComment);
                }
              }
            break;
          }
        }
      }
    },

    createParkNoteCommentData(state, payload){
      if(typeof payload.parkNoteId === 'undefined') return;

      // List以外のMetaKeyを処理します。
      for(let key of state.metaKeys){
        if(typeof payload[key] === 'undefined'){
          payload[key] = null;
        }
      }

      if(payload.currentPage === null){
        payload.currentPage = payload.page;
      }

      if(payload.behaviour === null){
        payload.behaviour = 'refresh';
      }

      state.parkNoteComments.push({
        parkNoteId  : payload.parkNoteId,
        behaviour   : payload.behaviour,
        list        : [],
        loaded      : payload.loaded,
        page        : payload.page,
        lastPage    : payload.lastPage,
        total       : payload.total,
        currentPage : payload.currentPage
      });
    },

    deleteParkNoteCommentData(state, payload){
      for(let i = 0; i < state.parkNoteComments.length; i++){
        if(payload.parkNoteId === state.parkNoteComments[i].parkNoteId){
          const newList = [];

          for(let commentData of state.parkNoteComments[i].list){
            if(payload.parkNoteCommentId !== commentData.id){
              newList.push(commentData);
            }
          }

          state.parkNoteComments[i].list = newList;
        }
      }
    },
    
    resetStore(state){
      state.parkNoteId        = null;
      state.parkNoteComments  = [];
    }
  },

  actions     : {
    updateParkNoteId(context, payload){
      context.commit('setParkNoteId', payload);
    },

    updateParkNoteCommentData(context, payload){
      // 既に登録されている場合のアップデート処理
      for(let i = 0; i < context.state.parkNoteComments.length; i++){
        if(context.state.parkNoteComments[i].parkNoteId === payload.parkNoteId){
          payload.parkNoteCommentIndex = i;
          
          // Metaデータのアップデートを実行します。
          context.commit('changeParkNoteCommentMetaData', payload);

          // Listデータのアップデートを実行します。(payload内に存在する場合)
          context.commit('changeParkNoteCommentListData', payload);

          return;
        }
      }

      context.dispatch('createNewParkNoteCommentData', payload);
    },

    createNewParkNoteCommentData(context, payload){
      // 新規に登録する場合
      context.commit('createParkNoteCommentData', payload);

      // listを更新します。（Listデータはこちらで登録します。）
      // Listデータのアップデートを実行します。(payload内に存在する場合)
      context.commit('changeParkNoteCommentListData', payload);
    },

    deleteParkNoteCommentData(context, payload){
      context.commit('deleteParkNoteCommentData', payload);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}